import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../styles/login-page.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [validated, setValidated] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Por favor, informe um email válido');
      setValidated(true);
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      // Simulação de envio de email de recuperação
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      setSuccess(true);
      setEmail('');
    } catch (error) {
      console.error('Erro ao solicitar redefinição de senha:', error);
      setError('Não foi possível processar sua solicitação. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo-container">
          <div className="login-logo">
            <img src="/logo-mm-eventos.png" alt="MM Eventos®" />
          </div>
          <div className="brand-text">Portal de Expositores</div>
        </div>
        
        <div className="login-form-container">
          <div className="login-form-content">
            <h1>Recuperar Senha</h1>
            <p className="login-subtitle">Informe seu email para receber instruções</p>
            
            {error && (
              <Alert variant="danger" className="login-alert">
                {error}
              </Alert>
            )}
            
            {success ? (
              <div className="text-center">
                <Alert variant="success" className="mb-4">
                  Enviamos um email com instruções para redefinir sua senha. Por favor, verifique sua caixa de entrada.
                </Alert>
                
                <Link to="/login" className="btn btn-primary login-button">
                  Voltar para o Login
                </Link>
              </div>
            ) : (
              <Form className="login-form" onSubmit={handleSubmit}>
                <Form.Group className="login-form-group">
                  <Form.Control 
                    type="email" 
                    placeholder="Seu email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={`login-input ${validated && !email ? 'is-invalid' : ''}`}
                    disabled={loading}
                  />
                  {validated && !email && (
                    <div className="login-validation-feedback">
                      O email é obrigatório
                    </div>
                  )}
                </Form.Group>
                
                <Button 
                  variant="primary" 
                  type="submit" 
                  className="login-button"
                  disabled={loading}
                >
                  {loading ? 'Enviando...' : 'Enviar Instruções'}
                </Button>
                
                <div className="text-center mt-3">
                  <Link to="/login" className="login-forgot-password">
                    Voltar para o Login
                  </Link>
                </div>
              </Form>
            )}
          </div>
        </div>
        
        <div className="login-footer">
          <p>© {new Date().getFullYear()} MM Eventos®</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;